<template>
  <div>
    <PageHeader @scroll-to-exclusion-details="scrollToPoint" />
    <TierUpgrade />
    <GamifiedOfferBanner v-if="brand === 'mcom'" />
    <Offer />
    <CreditCardOffer @scroll-to-exclusion-details="scrollToPoint" />
    <TriplePointsDays v-if="brand === 'bcom'" />
    <Benefits @scroll-to-exclusion-details="scrollToPoint" />
    <Perks @scroll-to-exclusion-details="scrollToPoint" />
    <PersonalStylistBanner v-if="brand === 'mcom'" />
    <EarnRate />
    <HelpFulLinks />
    <Exclusions />
  </div>
</template>

<script setup>
import { brand } from '../config';
import PageHeader from './pageHeader/pageHeader';
import Offer from './offers/Offer';
import Benefits from './benefits/Benefits';
import TriplePointsDays from './triplepointsdays/TriplePointsDays';
import Perks from './perks/Perks';
import HelpFulLinks from './helpfullinks/HelpFulLinks';
import Exclusions from './exclusions/Exclusions';
import TierUpgrade from './tierupgrade/TierUpgrade';
import CreditCardOffer from './creditCardOffer/creditCardOffer';
import EarnRate from './earnRate/EarnRate';
import PersonalStylistBanner from './personalStylistBanner/personalStylistBanner';
import GamifiedOfferBanner from './gamifiedOffers/GamifiedOffers';
import scrollToPoint from '../utils/scrollToPointUtil';
</script>
